import { Colors } from '@estee/elc-base-theme';

export const inputTheme = () => `
    background: ${Colors.white};
    border-color: ${Colors.blackDisabledEmphasis};
    border-radius: 4px;
`;

export const disabledInputTheme = () => `
    background: ${Colors.white};
    color: ${Colors.primary500};
    border-color: ${Colors.blackDisabledEmphasis};
    border-radius: 4px;
`;

export const focusInputTheme = () => `
    border-color: ${Colors.black};
    outline-width: 0;
`;

export const errorInputTheme = () => `
    border-color: ${Colors.danger};
    color: ${Colors.danger};
`;

export const floatingLabelTheme = () => `
    background: ${Colors.white};
    border-top-color: ${Colors.white};
`;

export const errorFloatingLabelTheme = () => `
    color: ${Colors.danger};
`;

export const AlertIconTheme = () => `
    fill: ${Colors.danger};
`;

export const ValidIconTheme = () => `
    fill: ${Colors.success};
`;

export const EyeIconTheme = () => `
    fill: ${Colors.primary700};
`;

//StyledLabel
export const TextBackgroundColorTheme = () => `
    background-color: ${Colors.white};
`;

export const ErrorTextTheme = () => `
    color: ${Colors.danger};
`;

export const StyledLabelMovedUpTheme = `
    font-size: 12px;
`;

export const floatingLabelRequiredWrapperTheme = `
    &:after {
        content: '*'
    }
`;
